import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Box } from 'reactjs-admin-lte'
import StockStore from 'stores/StockStore'
import { Row, Col, Button  } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import './Stock.css'
// import FontAwesome from 'react-fontawesome'
// var NotificationSystem = require('react-notification-system')
const storageKey = 'fasttrack.product.quickview'
class ProductQuickView extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      data:{files:[],location:[],lot:[],price:[],product:{shop_list:[]},replacement:[]},
      dataQV:JSON.parse(sessionStorage.getItem(storageKey)) || []
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData(this.props.itemnum)
  }

  componentWillReceiveProps(newPros) {
    if (newPros.itemnum&&newPros.itemnum!==this.props.itemnum ) {
      this.loadData(newPros.itemnum)
    }
  }

  loadData(itemnum) {
    let {dataQV} = this.state
    if(itemnum>0){
      this.setState({loading:true})
      let findDup = dataQV.findIndex(x=>x.product.itemnum===itemnum)
      if (findDup===-1) {
        StockStore.loadNewImages('genpart',itemnum,(result)=>{
          let data = result.data
          if (typeof data.product.itemnum!=='undefined') {
            this.setState({data:data,loading:false})
            dataQV.push(result.data)
          } else {
            this.setState({loading:false}) 
            let qv = JSON.parse(JSON.stringify(result.data))
            qv.product = Object.assign({itemnum:itemnum,shop_list:[]},qv.product)
            dataQV.push(qv)
          }  
          sessionStorage.setItem(storageKey, JSON.stringify(dataQV))
          this.setState({dataQV:dataQV})  
        })
      } else {
        let data = JSON.parse(JSON.stringify(dataQV[findDup]))
        this.setState({data:data,loading:false}) 
      } 
    } else {
      let qv = {
        assembling: [],
        files: [],
        location: [],
        lot: [],
        price: [],
        product: {itemnum: "", shop_list: []},
        replacement: []
      }  
      this.setState({data:qv,loading:false})
    }
  }

  renderSection0() {
    let {messages} = this.props
    let {data} = this.state
    return(
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">{messages['General']}</legend>
                <Row>
                  <Col md={12}>
                    <table className='table table-product-quick-view' style={{marginBottom:'0'}}>
                      <tbody>
                        <tr>
                          <td colSpan={2}><span className='title'>{messages['Description']} : </span> {data.product.description===''?'-':data.product.description}</td>
                        </tr>
                        <tr>
                          <td><span className='title'>{messages['Category']} : </span> {data.product.cat_name===''?'-':data.product.cat_name}</td>
                          <td><span className='title'>{messages['Sub category']} : </span> -</td>
                        </tr>
                        <tr>
                          <td><span className='title'>{messages['Product code']} : </span> {data.product.productcode===''?'-':data.product.productcode}</td>
                          <td><span className='title'>{messages['Barcode']} : </span> {data.product.barcode===''?'-':data.product.barcode}</td>
                        </tr>
                        <tr>
                          <td><span className='title'>{messages['Brand']} : </span> {data.product.brand?'-':data.product.brand}</td>
                          <td><span className='title'>{messages['Used with cars']} : </span> -</td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </fieldset>
    )
  }

  renderSection1() {
    let {messages} = this.props
    let {data} = this.state
    return(
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">{messages['Cost']}</legend>
                <Row>
                  <Col md={12}>
                    <table className='table table-product-quick-view' style={{marginBottom:'0'}}>
                      <tbody>
                        <tr>
                          <td><span className='title'>{messages['Cost per unit']} : </span> {data.product.cost_per_unit===''?'-':data.product.cost_per_unit}</td>
                          <td><span className='title'>{messages['Average cost per unit']} : </span> {data.product.cost_avg_per_unit===''?'-':data.product.cost_avg_per_unit}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>    
                </Row>
              </fieldset>
    )
  }

  renderSection2() {
    let {messages} = this.props
    let {data} = this.state
    return(
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">{messages['Stock']}</legend>
                <Row>
                  <Col md={12}>
                    <table className='table table-product-quick-view' style={{marginBottom:'0'}}>
                      <tbody>
                        <tr>
                          <td><span className='title'>{messages['Quantity']} : </span> {data.product.quantity===''?'-':data.product.quantity}</td>
                          <td><span className='title'>{messages['Standard selling price']} : </span> {data.product.price_per_unit===''?'-':data.product.price_per_unit}</td>
                        </tr>
                        <tr>
                          <td>
                          {data.location.map((item,index)=>
                            <div key={index}><span className='title'>{item.location_name===''?'-':item.location_name} : </span> {item.quantity===''?'-':item.quantity}</div>
                          )}
                          </td>
                          <td>
                          {data.price.map((item,index)=>
                            <div key={index}><span className='title'>{item.price_name===''?'-':item.price_name} : </span> {item.price_per_unit===''?'-':item.price_per_unit}</div>
                          )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>    
                </Row>
              </fieldset>
    )
  }

  renderSection3() {
    let {messages} = this.props
    let {data} = this.state
    let replacementL = [], replacementR = []
    let i = 0
    data.replacement.forEach((item,index)=>{
      item = Object.assign({seq:index+1},item)
      if (i>0) {
        replacementR.push(item)
        i = 0
      } else {
        replacementL.push(item)
        i++
      }  
    })
    return(
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">{messages['Replacement parts']}</legend>
                <Row>
                  <Col>
                    <table className='table table-product-quick-view' style={{marginBottom:'0'}}>
                      <tbody>
                        <tr>
                          <td>
                          {replacementL.map((item,index)=>
                            <div key={index}><span className='title'>{messages['Replacement parts']} {item.seq===''?'-':item.seq} : </span> {item.productcode===''?'-':item.productcode}</div>
                          )}
                          </td>
                          <td>
                          {replacementR.map((item,index)=>
                            <div key={index}><span className='title'>{messages['Replacement parts']} {item.seq===''?'-':item.seq} : </span> {item.productcode===''?'-':item.productcode}</div>
                          )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>    
                </Row>
              </fieldset>
    )
  }

  renderSection4() {
    let {messages} = this.props
    let {data} = this.state
    return(
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">{messages['Stock alerts']}</legend>
                <Row>
                  <Col md={12}>
                    <table className='table table-product-quick-view' style={{marginBottom:'0'}}>
                      <tbody>
                        <tr>
                          <td><span className='title'>{messages['Order alerts']} : </span> {data.product.warning_quantity===''?'-':data.product.warning_quantity}</td>
                          <td><span className='title'>{messages['Almost out alerts']} : </span> {data.product.error_quantity===''?'-':data.product.error_quantity}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>    
                </Row>
              </fieldset>
    )
  }

  renderSection5() {
    let {messages} = this.props
    let {data} = this.state
    return(
            <div>  
              <Row>
                <Col md={12}>
                  <table className='table table-product-quick-view' style={{marginBottom:'0'}}>
                    <tbody>
                      <tr>
                        <td colSpan={2}><span className='title'>{messages['Shelf']} : </span> {data.product.location===''?'-':data.product.location}</td>
                      </tr>
                      <tr>  
                        <td colSpan={2}><span className='title'>{messages['Remark']} : </span> {data.product.remark===''?'-':data.product.remark}</td>
                      </tr>
                      <tr>  
                        <td colSpan={2}><span className='title'>{messages['Shop']} : </span> {data.product.shop_list.map((item,index)=>(
                          <span key={index}>{item.name+(index===data.product.shop_list.length-1?'':', ')}</span>
                        ))}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </div>      
    )
  }

  renderProduct() {
    let {loading,data} = this.state
    return (
      <div>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>{data.product.description} - {data.product.productcode}</Box.Title>
            <div className='pull-right'>              
              <Button onClick={this.props.onClose}><FontAwesome name='close'></FontAwesome></Button>
            </div>
          </Box.Header>
          <Box.Body>
            <div className='product-quick-view'>
              {this.renderSection0()} 
              {this.renderSection1()} 
              {this.renderSection2()} 
              {data.replacement.length>0?this.renderSection3():''} 
              {this.renderSection4()} 
              {this.renderSection5()}
            </div>
          </Box.Body>
        </Box>
      </div>
    )
  }

  render(){
    let {show} = this.props
    let overlayStyle = {width:0}
    if(show){
      overlayStyle = {width:300}
    }
    return (
      <div className="product-overlay" style={overlayStyle}>
        {this.renderProduct()}
      </div>
    )
  }
}

ProductQuickView.defaultProps = {
  itemnum:null,
  show:false,
  onClose:()=>{},
  onMinimize:()=>{}
}

export default ProductQuickView = connect(
  (state) => ({messages: state.message.view.stock.ProductQuickView}),null,null,{withRef:true}
)(ProductQuickView);


// WEBPACK FOOTER //
// ./src/view/stock/ProductQuickView.js